import React from 'react';
import { IMessage } from 'models';

interface MessageCardProps {
  isReceived: boolean;
  message: any;
  isPrivateChat: boolean;
  setReplyTo: () => any;
}

const MessageCard: React.FC<MessageCardProps> = ({
  isReceived,
  message,
  isPrivateChat,
  setReplyTo,
}) => {
  // Function to check if the message text is an image URL
  const isImageUrl = (text: string) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(text);
  };

  console.log('isReceived', isReceived);

  return (
    <div className={`flex flex-col w-full px-4 ${isReceived ? 'items-start' : 'items-end'}`}>
      {message.type === 'attachment' || isImageUrl(message.text) ? (
        <div className="flex flex-col px-[5%] py-[4%] shadow-md max-w-[80%] min-w-[60%] h-fit my-[0.7%] rounded-lg bg-[#5B5D6B]">
          <img
            src={message.text}
            alt="attachment"
            className="w-full max-h-52 object-contain"
            onError={(e) => {
              e.currentTarget.style.display = 'none'; // Hide broken images
              console.error('Failed to load image:', message.text);
            }}
          />
          <div className="flex justify-between w-full border-t pt-[2%] mt-[2%] text-sm font-medium text-white">
            {!isPrivateChat && <span className="text-xs">{message.author.name}</span>}
            <span className="text-xs">{message.time}</span>
          </div>
        </div>
      ) : (
        <div className="flex flex-col px-[5%] py-[4%] shadow-md max-w-[80%] min-w-[60%] h-fit my-[0.7%] rounded-lg bg-[#5B5D6B]">
          <p className="text-white text-base font-medium">{message.text}</p>
          <div className="flex justify-between w-full border-t pt-[2%] mt-[2%] text-sm font-medium text-white">
            {!isPrivateChat && <span className="text-xs">{message.author.name}</span>}
            <span className="text-xs">{message.time}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageCard;